import { render, staticRenderFns } from "./modal-task-due-date.vue?vue&type=template&id=d16d30d8&"
import script from "./modal-task-due-date.vue?vue&type=script&lang=ts&"
export * from "./modal-task-due-date.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports